import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_CATEGORIES_IM } from 'constants/url';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { ICategories, ICategoriesList } from 'interfaces/imCategories.interface';

export default function useCategoriesIM() {
  const { jwt } = useUser();
  const { showNotistack } = useCustomSnackbar();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getCategories = (): Promise<ICategoriesList> => {
    return axios
      .get(URL_CATEGORIES_IM, { headers })
      .then((result: AxiosResponse) => {
        return result.data;
      })
      .catch(() => {
        showNotistack({ message: 'Ocurrió un error, por favor comuniquese con el administrador' });
      });
  };

  const getCategoryById = (wareHouseId: string): Promise<ICategories> => {
    return axios.get(`${URL_CATEGORIES_IM}/${wareHouseId}`, { headers }).then((result: AxiosResponse) => {
      if (result.status === 200) {
        return result.data;
      } else {
        return null;
      }
    });
  };

  const addCategory = (data: any): Promise<boolean> => {
    return axios.post(URL_CATEGORIES_IM, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 201;
    });
  };

  const updateCategory = (data: any): Promise<boolean> => {
    if (!data.id) throw new Error('El campo id es obligatorio');
    return axios.put(`${URL_CATEGORIES_IM}/${data.id}`, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 200;
    });
  };

  const deleteCategory = (warehouseId: string): Promise<boolean> => {
    if (!warehouseId) throw new Error('El campo id es obligatorio');
    return axios.delete(`${URL_CATEGORIES_IM}/${warehouseId}`, { headers }).then((response: AxiosResponse) => {
      return response.status === 204;
    });
  };

  return {
    getCategories,
    getCategoryById,
    addCategory,
    updateCategory,
    deleteCategory
  };
}
